// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/1.5.0/css/" + chunkId + "." + {"pages/MyReviewEdit":"ae06aae5","src_components_CustomDialog_DialogFooter_index_tsx-src_components_MediaExpandedView_index_tsx-17ca7a":"b0fedaea","pages/MyReviewPage":"3d0538d4","pages/PostReview":"164272ab","pages/ProviderReview":"db1de0cf"}[chunkId] + ".chunk.css";
};